import { Box } from "@mui/material";
import { ChatMessageWithParts } from "src/views/assistant/types";

type AssistantTextContainerProps = {
  messageIndex: number;
  chatMessage?: ChatMessageWithParts;
  children: React.ReactNode;
};

const AssistantTextContainer = ({
  messageIndex,
  chatMessage,
  children,
}: AssistantTextContainerProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <div
        className="chat-bubble"
        id={`chat-bubble-text-${chatMessage?.type}-${messageIndex}`}
      >
        {children}
      </div>
    </Box>
  );
};

export default AssistantTextContainer;
